import { validateArguments } from '../../SignatureValidation';
export var Log10Fn;
(function (Log10Fn) {
    Log10Fn.Name = `LOG10`;
    Log10Fn.Stage = "SCALAR";
    Log10Fn.Signature = `LOG10(<numeric-expression>)`;
    function make(callName, args, type, role) {
        return {
            name: Log10Fn.Name,
            stage: Log10Fn.Stage,
            data: { type, role },
            value: (...argVals) => {
                const value = argVals[0];
                if (value == null) {
                    return null;
                }
                if (typeof value === 'number') {
                    if (value <= 0) {
                        throw new Error(`Input to LOG10 must be greater than zero`);
                    }
                    return Math.log10(value);
                }
                throw new Error(`Invalid input for LOG10 ${value}`);
            },
        };
    }
    Log10Fn.make = make;
    function validate(callNode, callName, args) {
        const sig = {
            meta: { name: Log10Fn.Name, signature: Log10Fn.Signature, location: callNode.location },
            arguments: ["NUMERIC"],
        };
        return validateArguments(sig, args);
    }
    Log10Fn.validate = validate;
})(Log10Fn || (Log10Fn = {}));
